var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBackArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6051 12.0002C19.6051 12.4402 19.2451 12.8002 18.8051 12.8002H7.12509L10.7451 16.4402C11.0651 16.7602 11.0651 17.2602 10.7451 17.5802C10.5851 17.7402 10.3851 17.8202 10.1851 17.8202C9.98509 17.8202 9.76509 17.7402 9.62509 17.5802L4.64509 12.5802C4.32509 12.2602 4.32509 11.7602 4.64509 11.4602L9.62509 6.46021C9.94509 6.14021 10.4451 6.14021 10.7651 6.46021C11.0851 6.78021 11.0851 7.28021 10.7651 7.60021L7.12509 11.2002H18.8051C19.2451 11.2002 19.6051 11.5602 19.6051 12.0002Z",
    fill: "#F5D016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBackArrowIcon);
export default __webpack_public_path__ + "static/media/new_back_arrow_icon.da713dd91833771c90079724506858bc.svg";
export { ForwardRef as ReactComponent };